import { Data } from "../textInterfaces";

export const isWithFormFieldIdInComponentName = (
  component: Data,
  formFieldId: string,
): boolean => {
  const componentNameLevel3 = component.name.split(".")[2];
  return componentNameLevel3.includes(formFieldId.toLowerCase());
};
